import { createContext } from 'use-context-selector';
export const StickyValueContext = createContext(null);
export const StickyControlContext = createContext(null);
//# sourceMappingURL=StickyContext.js.map